import { useQuery } from '@tanstack/react-query'
import { api } from './api'

export interface Me {
  user: { id: string; email: string; name: string; locale?: string | null } | null
  memberships: { workspaceId: string; name: string; role: 'owner' | 'admin' | 'finance' | 'viewer' }[]
  partner: { id: string; name: string } | null
  fresh: boolean
  mfa?: { aal: 'aal1' | 'aal2' | null; required: boolean }
}

export const useMe = () =>
  useQuery({ queryKey: ['me'], queryFn: () => api<Me>('/api/me'), staleTime: 30_000 })

export function currentWorkspace(me: Me | undefined): string | null {
  if (!me?.memberships.length) return null
  let saved: string | null = null
  try {
    saved = localStorage.getItem('rg_ws')
  } catch {}
  return me.memberships.find((m) => m.workspaceId === saved)?.workspaceId ?? me.memberships[0]!.workspaceId
}

export function setWorkspace(id: string) {
  try {
    localStorage.setItem('rg_ws', id)
  } catch {}
}

export async function signOut() {
  await fetch('/api/auth/sign-out', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: '{}',
  })
  location.href = '/login'
}

export async function sendMagicLink(email: string, callbackURL: string, turnstileToken?: string | null) {
  return api('/api/auth/sign-in/magic-link', { body: { email, callbackURL, turnstileToken } })
}
